import React, { useCallback, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import queryString from 'query-string'
import { Button, Card, Grid } from '@mui/material'
import AddIcon from '@mui/icons-material/Add'

import Helmet from '../../../../../../components/Helmet'
import HeaderContent from '../../../../../../components/Layouts/HeaderContent'
import { ContentWrapper } from '../../../../../../components/ContentWrapper'
import { DistributionChannelFormModal } from '../../components/DistributionChannelFormModal'
import useAxios from '../../../../../../hooks/useAxios'
import { PaginationResponseInterface } from '../../../../../../types/pagination'
import { EDistributionChannelType, IDistributionChannel } from '../../../../../../types/distribution-channel'
import DistributionChannelFilter, { IFilterMapped } from '../../components/DistributionChannelFilter'
import DistributionChannelsTable from '../../components/DistributionChannelsTable'
import PageUrls from '../../../../../../constants/page-urls'

const Menus: any[] = []

const DistributionChannelsListPage = () => {
  const navigate = useNavigate()
  const queryStr = queryString.parse(window.location.search)
  const [isModalCreateDistributionChannels, setIsModalCreateDistributionChannels] = useState<boolean>(false)
  const [searchFilter, setSearchFilter] = useState<IFilterMapped>({
    page: Number(queryStr.page ?? 1),
    perPage: 15,
  })
  const [filter, setFilter] = useState<IFilterMapped>({
    page: Number(queryStr.page ?? 1),
    perPage: 15,
    name: queryStr.name?.length ? String(queryStr.name) : undefined,
    type: queryStr.type?.length ? String(queryStr.type) as EDistributionChannelType : undefined,
    url: queryStr.url?.length ? String(queryStr.url) : undefined,
  })

  const onFilterChange = useCallback((newFilter: IFilterMapped) => {
    setFilter(newFilter)
  }, [setFilter])

  const handleSearch = (newFilter: IFilterMapped) => {
    setFilter(newFilter)
    setSearchFilter(newFilter)
    const newQuery = queryString.stringify({ ...newFilter })
    navigate(`${PageUrls.Setting.DistributionChannels}?${newQuery}`, {
      replace: true,
    })
  }

  useEffect(() => {
    handleSearch(filter)
  }, [])

  const distributionChannelList = useAxios<PaginationResponseInterface<IDistributionChannel>>
    ({
      method: 'GET',
      url: '/distribution-channels',
      params: {
        ...searchFilter,
        type: searchFilter.type as any === 'all' ? undefined : searchFilter.type,
      },
    })

  const onUpdateDistributionChannelsSuccess = useCallback(async () => {
    try {
      await distributionChannelList.mutate()
    } catch (error) {
    }
  }, [filter])

  return (
    <ContentWrapper>
      <Helmet title="ช่องทางการขาย" />
      <DistributionChannelFormModal
        isOpen={isModalCreateDistributionChannels}
        onClose={(visible: boolean) => setIsModalCreateDistributionChannels(visible)}
        onUpdateDistributionChannelsSuccess={onUpdateDistributionChannelsSuccess}
      />
      <Grid
        container
        justifyContent="space-between"
        alignItems="center">
        <Grid item>
          <HeaderContent
            goBack
            title="ช่องทางการขาย"
            routes={Menus}
            descriptions="ช่องทางการขาย"
          />
        </Grid>
        <Grid item mb={2}>
          <Button variant="contained" size="large" startIcon={<AddIcon />}
            onClick={() => setIsModalCreateDistributionChannels(true)}>
            ช่องทางการขาย
          </Button>
        </Grid>
      </Grid>
      <Card
        sx={{
          padding: 2,
        }}>
        <DistributionChannelFilter
          filter={filter}
          onFilterChange={onFilterChange}
          onSearch={handleSearch}
        />
        <DistributionChannelsTable
          isLoading={distributionChannelList.isLoading}
          data={distributionChannelList.data?.records ?? []}
          onUpdateDistributionChannelsSuccess={onUpdateDistributionChannelsSuccess}
          filter={filter}
          onFilterChange={handleSearch}
          total={distributionChannelList.data?.count ?? 0}
        />
      </Card>
    </ContentWrapper>
  )
}

export default DistributionChannelsListPage